/**
 * App
 */

import Vue from "components/base";
import { Component } from "vue-property-decorator";
import template from "./App.vue";
import NavBar from "components/NavBar";

@Component({
  name: "App",
  mixins: [template],
  components: {
    NavBar
  }
})
export default class App extends Vue {
  get navBar() {
    const list = ["home", "product", "about", "join", "warn"];
    const page = this.$route.name;

    return list.indexOf(page) > -1;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/pages/App/App.ts